"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModelsAccess = void 0;
const getModelsWithAddedAccess_1 = require("../selectors/getModelsWithAddedAccess");
const useModels_1 = require("./useModels");
function useModelsAccess(models) {
    const defaultModels = (0, useModels_1.useModels)();
    return (0, getModelsWithAddedAccess_1.getModelsWithAddedAccess)()(models !== null && models !== void 0 ? models : defaultModels);
}
exports.useModelsAccess = useModelsAccess;
